import { gql } from "@apollo/client"
import { RegisterSystemTask } from "event-definitions"
import { createEvent } from "library/local-events/index.mjs"
import { replaceAllWith } from "lib/@components/slot/replace-all-with"
import { Frag } from "lib/@components/slot/frag"
import { mutate } from "lib/graphql/mutate"
import { confirm } from "lib/@dialogs/confirm"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { TaskEditor } from "slot-definitions"

const RegenerateAllSteps = createEvent("regenerateAllSteps")

RegisterSystemTask.handleOnce(({ tasks }) => {
    tasks.push({
        name: "Regenerate AI steps",
        event: RegenerateAllSteps.eventName,
        params: {},
    })
})

TaskEditor(RegenerateAllSteps.eventName).plug(replaceAllWith(<Frag />))

RegenerateAllSteps.handleOnce(async () => {
    const ok = await confirm(
        "This queues a one-off regeneration of every AI step in the core library and all live regimes. It makes a large number of AI calls and runs in the background.",
        "Regenerate AI steps"
    )
    if (!ok) return
    try {
        const run = await mutate(
            gql`
                mutation RegenerateAllSteps {
                    regenerateAllSteps
                }
            `,
            {},
            { returns: "regenerateAllSteps" }
        )
        successSnackbar(`Step regeneration queued (run ${run?.runId}, job ${run?.jobId})`)
    } catch (e) {
        console.error(e)
        errorSnackbar(e.message)
    }
})
